import React from 'react';
import PropTypes from 'prop-types';
import { Icon as LegacyIcon } from '@ant-design/compatible';
import { List, Spin, Col, Row, Skeleton, Tooltip } from 'antd';
import { Link, withRouter } from 'react-router-dom';
import { FormattedRelativeTime, FormattedMessage, FormattedDate, FormattedNumber } from 'react-intl';
import InfiniteScroll from 'react-infinite-scroller';
import { bindActionCreators } from 'redux'
import { connect } from "react-redux";
import notifsActions from '../../actions/notifs';
import * as notifsSelectors from '../../selectors/notifs';
//import { createFromMysql } from '../../utilities/dateUtils';
import { GlobalConfigContext } from '../Config/GlobalConfigContext';
import { isMobile as isMobileCheck } from 'react-device-detect';
import moment from 'moment';
import {selectUnit} from '@formatjs/intl-utils';

// Set the name of the hidden property and the change event for visibility
let hidden, visibilityChange;
if (typeof document.hidden !== "undefined") { // Opera 12.10 and Firefox 18 and later support 
    hidden = "hidden";
    visibilityChange = "visibilitychange";
} else if (typeof document.msHidden !== "undefined") {
    hidden = "msHidden";
    visibilityChange = "msvisibilitychange";
} else if (typeof document.webkitHidden !== "undefined") {
    hidden = "webkitHidden";
    visibilityChange = "webkitvisibilitychange";
}

class MessagesList extends React.PureComponent {    
    static contextType = GlobalConfigContext;
    state = {
        hasMore: true,
    }
    constructor(props, context) {
        super(props);
        if (isMobileCheck) {
            document.addEventListener(visibilityChange, this.handleVisibilityChange, false);
        }
    }
    handleVisibilityChange = () => {
        if (!document[hidden]) {
            this.fetchNotifications({ page: 1, limit: 20}, { appendResponse: false });
        }
    }
    componentDidMount() {
        this.fetchNotifications();
    }
    componentDidUpdate = (prevProps) => {
        if(this.props.records.length >= this.props.totalCount && this.state.hasMore){
            this.setState({
				hasMore: false
			});
        }
        if(prevProps.property !== this.props.property && this.props.property){
            this.fetchNotifications();
        }
    }
    fetchNotifications = (pagination={ page: 1, limit: 20}, options={ appendResponse: true } ) => {
        this.props.actions.fetch(this.props.instanceKey, pagination, options );
    }
    handleInfiniteOnLoad = (page) => {
        //console.log(`page:`, page)
        if(this.props.records.length < this.props.totalCount && this.state.hasMore){
            this.fetchNotifications({ page, limit: 20 });
            //this.props.actions.fetch(this.props.instanceKey, { page, limit: 10 }, { appendResponse: true } );
        }
    }
    handleRead = (item) => {
        if(item){
            this.props.actions.update(this.props.instanceKey, { id: item.id, is_read: !item.is_read }, { isAsync: true }).then(() => {
                if(this.props.onReadChange){
                    this.props.onReadChange(!item.is_read ? -1 : 1);
                }
            });
        }
    }
    markAsRead = (item) => {
        if(this.props.onHideList){
            this.props.onHideList(false);
        }
        if(item){
            this.props.actions.update(this.props.instanceKey, { id: item.id, is_read: 1 }, { isAsync: true }).then(() => {
                if(this.props.onReadChange && !item.is_read){
                    this.props.onReadChange(-1);
                }
            });
        }
	}
	handleFormatting = (value, c) => {
        let date = moment(value, 'YYYY-MM-DD', true);
        if (date.isValid()) {
            return <FormattedDate value={date} year='numeric' month='short' day='2-digit' />
        } else if (c.endsWith('_amount') || c.endsWith('price')) {
            return <FormattedNumber value={value} style='currency' currency={this.context.currencyCode} />
        } else if (c.endsWith('_percentage')) {
            return <FormattedNumber value={value} style='percent' />
        }
        else return value;
	}
    render() {
        const { records, isFetching } = this.props;
        //console.log(`records:`, records)
        const { hasMore } = this.state;
        const { ability } = this.context;
        const highlightMessage = (obj) => {
            return Object.keys(obj).reduce((p, c) => ({...p, [c]: <b>{this.handleFormatting(obj[c], c)}</b> }), {});
        }

        const readTooltip = (item) => {
            return (
                <Tooltip title={item.is_read ? <FormattedMessage id="messages.menu.unread" defaultMessage={`Unread`} />  : <FormattedMessage id="messages.menu.read" defaultMessage={`Read`} /> }>
                            <LegacyIcon type="eye" theme={item.is_read ? "outlined" : "filled"} value={item.id} onClick={() => this.handleRead({ id: item.id, is_read: item.is_read })} />
                        </Tooltip>
            );
        }
        return (
            <div className="messages-list-container">
                <InfiniteScroll
                    initialLoad={false}
                    pageStart={0}
                    loadMore={this.handleInfiniteOnLoad}
                    hasMore={!isFetching && hasMore}
                    useWindow={false}
                >
                    <List
                        dataSource={records.filter(item => item.messages)}
                        renderItem={item => 
                            {
                            const dateTime = item.created.replace(' ', 'T') + '.000Z';
                            //console.log(`dateTime:`, dateTime);
                            //let dateTimeParts= dateTime.split(/[- :]/); // regular expression split that creates array with: year, month, day, hour, minutes, seconds values
                            //dateTimeParts[1]--; // monthIndex begins with 0 for January and ends with 11 for December so we need to decrement by one
                            //const dateObject = new Date(...dateTimeParts);
                            const dateObject = new Date(dateTime);
                            //console.log(`dateObject:`, dateObject);
                            //console.log(`dateObject:`, dateObject, Date.now(), dateObject.getTime());
                            //const {value, unit} = selectUnit(Date.now() - dateObject.getMilliseconds());
                            const {value, unit} = selectUnit(Date.now() - (Date.now() - dateObject.getTime()));
                            //console.log(`value:`, value, unit, item.created, Date.now(), dateObject.getTime(), (Date.now() - (Date.now() - dateObject.getTime())), (Date.now() - 48 * 3600 * 1000));
                            //value={createFromMysql(item.created)}
                            
                            const disabled = item.messages && item.messages.link && item.messages.link.includes('reservations') && !ability.can('record:read', 'Reservation');
                            return item.messages ? <List.Item key={item.id} actions={[ !this.context.isMobile && readTooltip(item) ]} className={item.is_read ? 'is_read' : 'unread' }>
                            <Skeleton avatar title={false} loading={item.loading} active>
                                <Link to={item.messages.link || ''} onClick={(e) => this.markAsRead(item, e)} className="messages-link" disabled={disabled}>
                                    <Row type="flex" justify="center" style={{ width: '100%' }}>
                                        <Col span={3} className="messages-icon text-center">
                                            <LegacyIcon type={item.messages.message_types.icon} style={{ fontSize: 18 }} />
                                        </Col>
                                        <Col span={21} className="messages-body">
                                            {/* <span className="messages-body-title">New order created!</span> */}
                                            <span className="messages-body-content">
                                                <FormattedMessage
                                                    id={`notifications.${item.messages.message_types.name}`}
                                                    defaultMessage={item.messages.message_types.description_template}
                                                    //values={{ ...item.messages.message_object }}
                                                    values={{ ...highlightMessage(item.messages.message_object) }}
                                                />
                                            </span>
                                            { item.created && <small><FormattedRelativeTime value={value} unit={unit} numeric="auto" /></small>}
                                        </Col>
                                    </Row>
                                </Link>
                            </Skeleton>
                        </List.Item> : <List.Item key={item.id} actions={[ !this.context.isMobile && readTooltip(item) ]} className={item.is_read ? 'is_read' : 'unread' }></List.Item>;}}
                    >
                        {isFetching && this.state.hasMore && (
                        <div className="messages-loading-container">
                            <Spin />
                        </div>
                        )}
                    </List>
                </InfiniteScroll>
            </div>
        );
    }
}
MessagesList.propTypes = {
    record: PropTypes.object,
};
MessagesList.defaultProps = {
    instanceKey: 'notications',
};

const mapStateToProps = (state, ownProps) => {
	const instanceKey = ownProps.instanceKey ? ownProps.instanceKey : MessagesList.defaultProps.instanceKey;
	const defaultProps = {
		records: notifsSelectors.fetchDataset(state, instanceKey),
		totalCount: notifsSelectors.fetchProperty(state, instanceKey, 'total'),
		isFetching: notifsSelectors.fetchProperty(state, instanceKey, 'isFetching'),
		isSaving: notifsSelectors.fetchProperty(state, instanceKey, 'isSaving'),
		isDeleting: notifsSelectors.fetchProperty(state, instanceKey, 'isDeleting'),
		paginationParams: notifsSelectors.fetchProperty(state, instanceKey, 'pagination'),
		filterParams: notifsSelectors.fetchProperty(state, instanceKey, 'filters'),
		error: notifsSelectors.fetchProperty(state, instanceKey, 'error'),
	};

	return defaultProps;
}
const mapDispatchToProps = dispatch => ({
    actions: bindActionCreators(notifsActions, dispatch),
	dispatch
})

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(MessagesList));
